import { TextField } from '@mui/material'
import { styled } from '@mui/material/styles'

const CustomTextField = styled(TextField)(({ isauth = true, filled }) => ({
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderRadius: `25px`,
      borderColor: isauth ? `#a8a8a8` : filled ? `#00C9A785` : `#a8a8a8`,
    },
    '& input': {
      borderRadius: `25px`,
      borderColor: isauth ? `#a8a8a8` : filled ? `#00C9A785` : `#a8a8a8`,
    },
    borderRadius: `25px`,
    marginRight: `10px`,
    borderColor: isauth ? `#a8a8a8` : filled ? `#00C9A785` : `#a8a8a8`,
  },
  '& .MuiOutlinedInput-input': {
    background: '#FFFFFF00 !important',
  },
}))

export default CustomTextField
